import PropTypes from 'prop-types';
import React from 'react';
import { SelectInput as ReactAdminSelectInput, required as requiredFn } from 'react-admin';

export const SelectInput = ({ isRequired, validate, ...props }) => (
  <ReactAdminSelectInput
    {...props}
    validate={isRequired ? requiredFn() : validate}
  />
)

SelectInput.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  validate: PropTypes.func,
};

SelectInput.defaultProps = {
  sort: false,
  sortable: false,
  alwaysOn: true
};

export default SelectInput;

